import {Card,Form,Input,Button, message, Upload, Image} from 'antd'
import React, {useEffect, useState} from 'react'
import AxiosService from '../services/APIService';
import {EditOutlined, UploadOutlined} from '@ant-design/icons';
import ContactInput from '../components/ContactInput';
const {Item} = Form;
function EmailInfo() {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const axiosService = new AxiosService();
    const onFinish = (values) => {
        const formData = new FormData()

        formData.append('contactNumber', values.contactNumber)
        formData.append('email', values.email)
        formData.append('website',values.link)
        if(values?.email_heard?.length === 1) formData.append('header', values.email_heard[0].originFileObj)
        
        axiosService.post('/white-label/save-email-contacts', formData)
            .then(() => {
            message.success("Data Saved")
            })
            .catch(() => {
            message.error("Something Went wrong")
        })
    };

    useEffect(() => {
        fetchData()
    },[]);

    const fetchData = () => {
        axiosService.get('/white-label/get-email-contacts')
            .then(res => {
                form.setFieldValue("email", res?.data?.email)
                form.setFieldValue("contactNumber", res?.data?.contactNumber)
                form.setFieldValue("link", res?.data?.website)
            })
            .catch(e => {
            console.log(e);
        })
    }

    const normFile = (e) => {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
          return e;
        }
        return e?.fileList;
      };

    return (
        <Card title="Email Contact Information" style={{width: '30%'}}>
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Item
                    label="Email"
                    name="email"
                    rules={[
                        {required: true, message: 'Please enter your email!'},
                        {type: 'email', message: 'Please enter a valid email!'},
                    ]}
                >
                    <Input placeholder="Enter your email" />
                </Item>

                <ContactInput placeholder="Enter your contact number" form={form} name='contactNumber' label='Contact Number' />

                <Item
                    label="Youtube Link"
                    name="link"
                    rules={[
                        {required: true,message: 'Please enter your website!'},
                        {type: 'url',message: 'Please enter a valid URL!'},
                    ]}
                >
                    <Input placeholder="Enter your website URL" />
                </Item>
               
                
                <Item
                    name="email_heard"
                    label="Email Header"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                >
                    <Upload accept='.jpeg, .jpg, .png' beforeUpload={() => false} maxCount={1} name="logo" listType="text">
                        <Button icon={<UploadOutlined />}>Click to upload</Button>
                    </Upload>
                </Item>
                <Item>
                    <Button type="primary" htmlType="submit" block>
                        Submit
                    </Button>
                </Item>
            </Form>
        </Card>
    )
}

export default EmailInfo